import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Login from "@/pages/auth/Login";
import Register from "@/pages/auth/Register";
import ProtectedWorkspace from "./ProtectedWorkspace";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/workspace",
    element: <ProtectedWorkspace />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
